// todo: this is duplicate of common breakpointsMinWidth.js - replace it later
// mobile first design
export default {
  desktopLg: 'screen and (min-width:2560px)',
  desktopMd: 'screen and (min-width:1920px)',
  desktopHD: 'screen and (min-width:1600px)',
  desktopSm: 'screen and (min-width:1440px)',
  desktopMini: 'screen and (min-width:1366px)',
  tabletLg: 'screen and (min-width:1280px)',
  tabletMd: 'screen and (min-width:1024px)',
  tabletSm: 'screen and (min-width:768px)',
  mobileLg: 'screen and (min-width:425px)',
  mobileMicroLg: 'screen and (min-width:411px)',
  mobileMd: 'screen and (min-width:360px)',
  mobileSm: 'screen and (min-width:320px)',
};
